import { CampaignCommon } from '../declarations/campaign';
import { DeepReadonly } from '../declarations/deep-readonly';

export const getCampaignSkipIdentifier = (c: CampaignCommon | DeepReadonly<CampaignCommon>): string =>
  (c.adminId?.toString() || c.partnerId)!;
